import { useCallback, useMemo } from "react";

import type { IconName } from "@similarweb/icons";
import { SegmentedControl } from "@similarweb/ui-components";
import type { SegmentedControlValue } from "@similarweb/ui-components";

import type { LocationDevice } from "app/pages/digital-marketing/keywords-campaigns/shared/types";

const DEVICE_CONFIG: readonly { icon: IconName; value: LocationDevice }[] = [
    { icon: "desktop", value: "DESKTOP" },
    { icon: "mobile-web", value: "MOBILE" },
    { icon: "combined", value: "BOTH" },
];

type Props = {
    isDisabled?: boolean;
    disabledDevices?: LocationDevice[];
    selectedDevice: LocationDevice;
    onSelect: (device: LocationDevice) => void;
};

export const DevicePicker = ({ isDisabled, disabledDevices, selectedDevice, onSelect }: Props) => {
    const selectedIndex = DEVICE_CONFIG.findIndex((d) => d.value === selectedDevice);

    const options: SegmentedControlValue[] = useMemo(() => {
        const disabledSet = new Set(disabledDevices);
        return DEVICE_CONFIG.map((d) => ({ icon: d.icon, disabled: isDisabled || disabledSet.has(d.value) }));
    }, [isDisabled, disabledDevices]);

    const handleChange = useCallback(
        (index: number) => {
            onSelect(DEVICE_CONFIG[index].value);
        },
        [onSelect],
    );

    return (
        <div data-automation="gsc-device-picker">
            <SegmentedControl
                values={options}
                selectedIndex={selectedIndex}
                onChange={handleChange}
            />
        </div>
    );
};
